<template>
  <!--功能：修改密码
   创建日期：2020-06-22
  开发人员：liufu-->
  <!-- <div>
    <template v-slot:header>
      <div style="margin-right: 2px !important">修改密码</div>
      <el-tooltip
        content="请使用大写+小写英文+数字的组合密码"
        placement="right"
        effect="dark"
      >
        <div style="margin-top: -4px"><i class="vxe-icon--question"></i></div>
      </el-tooltip>
      <i
        title="关闭"
        v-show="showClose"
        class="vxe-modal--close-btn trigger--btn vxe-icon--close"
        @click="formVisible = false"
      ></i>
    </template> -->
  <div class="mian-box">
    <el-form
      size="mini"
      class="user-account-key"
      ref="FormRef"
      :model="form"
      :rules="rules"
    >
      <el-row justify="center">
        <el-col :span="24">
          <el-form-item label-width="100px" label="原密码" prop="oldPass">
            <el-input
              size="mini"
              type="password"
              placeholder="输入"
              v-model="form.oldPass"
            ></el-input>
            <template slot="error" slot-scope="slot">
              <errorTooltip :content="slot.error"></errorTooltip>
            </template>
          </el-form-item>
        </el-col>
      </el-row>
      <div style="height: 23px"></div>
      <el-row justify="center">
        <el-col :span="24">
          <el-form-item label-width="100px" label="新密码" prop="newPass">
            <el-input
              size="mini"
              type="password"
              placeholder="输入"
              show-password
              v-model="form.newPass"
            ></el-input>
            <template slot="error" slot-scope="slot">
              <errorTooltip :content="slot.error"></errorTooltip>
            </template>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row justify="center">
        <el-col :span="15" v-if="!showPwdLevel" style="height: 23px"></el-col>
        <el-col :span="24" v-else style="height: 23px">
          <div
            style="
              margin-left: 70px;
              color: #303133;
              font-size: 14px;
              display: flex;
            "
          >
            密码强度：
            <!-- <span style="font-size: 14px; margin-right: 2px" :style="pwdLevelColor">{{ pwdLevel }}</span> -->
            <pwsLevelBlock
              v-show="form.newPass.length >= 6"
              :level="pwdLevel"
            ></pwsLevelBlock>
          </div>
        </el-col>
      </el-row>
      <el-row justify="center">
        <el-col :span="24">
          <!-- <el-row> <el-col :span="24"></el-col></el-row> -->
          <el-form-item label-width="100px" label="确认密码" prop="newPass2">
            <el-input
              size="mini"
              type="password"
              placeholder="输入"
              show-password
              v-model="form.newPass2"
            ></el-input>
            <template slot="error" slot-scope="slot">
              <errorTooltip :content="slot.error"></errorTooltip>
            </template>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row justify="center">
        <el-col
          :span="15"
          v-if="!showValidRepeat"
          style="height: 23px"
        ></el-col>
        <el-col :span="24" v-else style="height: 23px"
          ><span style="margin-left: 70px; color: #67c23a; font-size: 14px"
            >密码输入一致✔</span
          ></el-col
        >
      </el-row>
    </el-form>
    <div class="bts-box">
      <el-button type="primary" size="mini" @click="onSubmit()">修改</el-button>
      <el-button size="mini" @click="$refs['FormRef'].resetFields()"
        >重置</el-button
      >
    </div>
    <!-- </div> -->
  </div>
</template>

<script>
import pwsLevelBlock from './pwdLeverBlock'
export default {
  props: {
    parentObj: Object,
    sqlTitle: {
      type: String,
      default: 'select'
    },
    showClose: {
      type: Boolean,
      default: true
    }
  },
  components: {
    pwsLevelBlock
  },
  data () {
    return {
      form: {
        oldPass: '',
        newPass: '',
        newPass2: ''
      },
      // 验证
      rules: {
      },
      // 是否显示
      formVisible: false,
      // 密码强度
      pwdLevel: '低',
      // 密码一致
      showValidRepeat: false,
      // 控制密码强度显示
      showPwdLevel: false
    }
  },
  mounted () {
    this.showWindows()
  },
  methods: {
    showWindows () {
      this.validPwdLevel()
      this.rules = {
        oldPass: [
          { required: true, message: '请输入原密码', trigger: 'change' },
          {
            min: 1,
            max: 16,
            message: '密码长度应在 1 到 16 个字符',
            trigger: 'change'
          }
        ],
        newPass: [
          { required: true, message: '请设置新密码', trigger: 'change' },
          { validator: this.validateNewPassword, trigger: 'change' },
          {
            min: 6,
            max: 16,
            message: '密码长度应在 6 到 16 个字符',
            trigger: 'change'
          }
        ],
        newPass2: [
          { required: true, message: '请确认新密码', trigger: 'change' },
          { validator: this.validateNewPassword2, trigger: 'change' },
          {
            min: 6,
            max: 16,
            message: '密码长度应在 6 到 16 个字符',
            trigger: 'change'
          }
        ]
      }
      this.$nextTick(() => {
        this.$refs.FormRef.clearValidate()
      })
    },
    validateNewPassword (rule, value, callback) {
      if (value === this.form.oldPass) {
        callback(new Error('新密码不能与原密码相同!'))
      } else {
        callback()
      }
    },
    validateNewPassword2 (rule, value, callback) {
      if (value !== this.form.newPass) {
        callback(new Error('与新密码不一致!'))
      } else {
        callback()
      }
    },
    // 提交修改密码
    async onSubmit () {
      this.$refs.FormRef.validate(async valid => {
        if (valid) {
          // if (this.pwdLevel === '低') {
          //   this.$message.error('密码强度不足,请重新输入(使用大写+小写英文+数字的组合密码)')
          //   return false
          // }
          // if (!this.pwdContinuity(this.form.newPass)) {
          //   this.$message.error('密码不能出现三位连续或三位重复的字符')
          //   return false
          // }
          const { data: res } = await this.$http.put('/Common/YKUser/pwd', {
            id: this.$store.state.userInfo.userId,
            oldPassword: this.$md5.md5(this.form.oldPass),
            newPassword: this.$md5.md5(this.form.newPass)
          })
          if (res.isSuccess) {
            this.$refs.FormRef.resetFields()
            // this.formVisible = false
            this.$message.success('修改密码成功')
            this.$emit('closeParent')
            // this.$emit('handleSure')
          } else {
            this.$message.error(res.errorMessage)
          }
        } else {
          this.$message.error('请正确填写信息')
          return false
        }
      })
    },
    // 监听模态框关闭
    closeWindows () {
      this.$refs['FormRef'].resetFields()
    },
    // 校验密码方法
    validPassword () {
      if (this.form.newPass2 !== '') {
        this.$refs.FormRef.validateField('newPass2')
        if (this.form.newPass2 === this.form.newPass) {
          this.showValidRepeat = true
        } else {
          this.showValidRepeat = false
        }
      }
    },
    // 校验密码强度
    validPwdLevel () {
      const pwdRegexLow = new RegExp(
        '(?=.*[0-9]).{6,16}|(?=.*[A-Z]).{6,16}|(?=.*[a-z]).{6,16}|(?=.*[A-Z])(?=.*[a-z]).{6,16}'
      )
      const pwdRegexIn = new RegExp('(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z]).{6,16}')
      const pwdRegexHigh = new RegExp('(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[^a-zA-Z0-9]).{6,16}')
      if (pwdRegexHigh.test(this.form.newPass)) {
        this.pwdLevel = '高'
      } else if (pwdRegexIn.test(this.form.newPass)) {
        this.pwdLevel = '中'
      } else if (pwdRegexLow.test(this.form.newPass)) {
        this.pwdLevel = '低'
      }
    },
    // 校验密码是否连续或重复
    pwdContinuity (pwd) {
      let arr = pwd.split('')
      let flag = true
      for (let i = 1; i < arr.length - 1; i++) {
        let firstIndex = arr[i - 1].charCodeAt()
        let secondIndex = arr[i].charCodeAt()
        let thirdIndex = arr[i + 1].charCodeAt()
        if (thirdIndex - secondIndex === 1 && secondIndex - firstIndex === 1) {
          flag = false
        }
      }
      let repeatRe = /(\w)*(\w)\2{2}(\w)*/g
      if (repeatRe.test(pwd)) {
        flag = false
      }
      return flag
    }
  },
  computed: {
    // 密码强度文字颜色
    pwdLevelColor () {
      switch (this.pwdLevel) {
        case '低':
          return 'color: #F56C6C'
        case '中':
          return 'color: #E6A23C'
        case '高':
          return 'color: #67C23A'
      }
      return ''
    }
  },
  watch: {
    'form.oldPass': {
      handler (newValue) {
        if (newValue === this.form.newPass) {
          this.showPwdLevel = false
          this.form.newPass !== '' && this.$refs.FormRef.validateField('newPass')
        }
      },
      deep: true
    },
    'form.newPass': {
      handler (newValue) {
        this.pwdContinuity(newValue)
        if (newValue.length > 0) {
          this.validPwdLevel(newValue)
          this.showPwdLevel = true
          this.validPassword()
        } else {
          this.showPwdLevel = false
          this.showValidRepeat = false
        }
        if (newValue === this.form.oldPass) {
          this.showPwdLevel = false
          // this.showValidRepeat = false
        }
      },
      deep: true
    },
    'form.newPass2': {
      handler (newValue) {
        if (newValue !== '') {
          if (newValue === this.form.newPass) {
            this.showValidRepeat = true
          } else {
            this.showValidRepeat = false
          }
        } else {
          this.showValidRepeat = false
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="less" scoped>
.mian-box {
  width: 100%;
}
/deep/ .vxe-modal--header {
  line-height: 17px;
  display: flex;
  align-items: center;
}
/deep/ .el-tooltip {
  font-size: 17px;
}
.bts-box {
  display: flex;
  justify-content: flex-end;
  top: 90%;
}
.error-icon {
  position: absolute !important;
  top: 26px !important;
  right: 0 !important;
}
</style>
